// 圖示元件 — name 直接係 emoji 字元 (PageHead/Modal 用)
// 註: 原版 Icons.jsx 未有 push 上 repo, 呢個係等效重建 — 如有 SVG 版本可換返
export default function Icon({ name, size }) {
  if (!name) return null;
  return <span className="icon" style={size ? { fontSize: size } : undefined}>{name}</span>;
}
